<template>
    <router-link :to="{ name: routeName, params: { slug: slug }}">
        <div class="item-news item-default">
            <div class="image">
                <div v-if="loading" class="text-center"><span class="loader red"></span></div>
                <ion-img :src="thumbnail" :alt="title" @ionImgDidLoad="hideLoader"/>
            </div>
            <div class="description">
                <div class="head">
                    <div class="date">{{ date }} - {{ time }}</div>
                </div>
                <h3 class="title h5">{{ title }}</h3>
                <div class="excerpt">{{ excerpt }}</div>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'ItemNews',
        props: ['routeName','slug', 'title','thumbnail','excerpt','date','time'],
        data(){
            return{
                loading: true
            }
        },
        methods: {
            hideLoader() {
                this.loading = false;
            }
        }
    }
</script>